import clg from "functions/log";
import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

export const _Skeleton = ( props ) => {

    let _props = {...props};
    let parentClass;
    let sameCount = null;

    if( props.hasOwnProperty("parentClass") ) {
        parentClass = props.parentClass;
        delete _props.parentClass;
    }

    if( props.hasOwnProperty("sameCount") ) {
        sameCount = props.sameCount;
        delete _props.sameCount;
    }

    const getSingle = ( key ) => {
        return (
            <div className={"_skeleton-container" + ( parentClass ? " " + parentClass : "" )} key={`_skeleton-item-${key}`}>
                <Skeleton {..._props} />
            </div>
        )
    }

    const getMultiple = () => {
        let skeletons = [];

        for(let i=0;i<sameCount;i++){
            skeletons.push( getSingle( i ) )
        }

        return skeletons;
    }

    return (
        <>
            {
                !sameCount ?
                getSingle( "single" )
                :
                getMultiple()
            }
        </>
    )

    //Ha a sameCount prop megvan adva, akkor "sameCount" mennyiségű ugyanolyan elemet kell kigenerálni
    /* if( typeof sameCount === "number" ) {
        let skeletons = [];
        for(let i=0; i< sameCount;i++){
            return {getSingle()}
        }
    } */

    
}

const SkeletonC = ({ skeletonProps, skeletonThemeProps }) => {

    let sTP = {...skeletonThemeProps};
    let sP = {...skeletonProps};

    //Alapértelmezett értékek
    let color = "#dfdfdf";
    let highlightColor = "#ebebeb";

    //Ha a SkeletonC komponensben van megadva a szín, akkor az alapértelmezett érték átállítása
    if( sTP.hasOwnProperty("color") ) {
        color = sTP.color;
        delete sTP["color"];
    }

    if( sTP.hasOwnProperty("highlightColor") ) {
        highlightColor = sTP.highlightColor;
        delete sTP["highlightColor"];
    }

    /* clg("skeletonProps: ", sTP);
    clg("skeletonProps: ", sP); */

    return (
        <SkeletonTheme {...sTP} /* color={color} highlightColor={highlightColor} */ >
            <Skeleton {...sP}/>
        </SkeletonTheme>
    )
}

export default SkeletonC;
